export enum FeeScheduleType {
  CLIENT = 'client',
  PROVIDER = 'provider'
}
